<template>
  <div class="pa-2">
    <div v-if="!isEmailDetailsOpen">
      <div
        v-for="(item, index) in response"
        :key="index"
        class="email-card d-flex align-center pl-2 position-relative mb-2"
      >
        <v-avatar color="info" size="40">
          <span class="white--text">BO</span>
        </v-avatar>
        <div class="flex-grow-1 ml-3 d-flex">
          <div style="width: 400px">
            <p class="mb-1 font-weight-bold hide-text">{{ item.subject }}</p>
            <p class="mb-0 text-caption hide-text">
              {{ item.snippet }}
            </p>
          </div>
        </div>
        <div class="position-absolute date-area">
          <span class="mb-0 secondary--text text-caption">
            {{
              formatDateToMonthShort(item.createdAt, {
                hour: 'numeric',
                minute: 'numeric',
              })
            }}
          </span>
        </div>
        <div
          class="position-absolute reply-area d-flex align-center cursor-pointer"
          @click="updateEmailViewData(item)"
        >
          <v-img
            :src="require('@/assets/images/svg/undo.svg')"
            width="18"
            height="12"
            class="mr-1"
          ></v-img>
          reply
        </div>
        <div class="position-absolute red-area cursor-pointer" @click="updateEmailViewData(item)">
          <v-icon color="white">{{ mdiChevronRight }}</v-icon>
        </div>
      </div>
      <div v-intersect="infiniteScrolling"></div>
      <div
        v-if="!response.length"
        class="email-card d-flex align-center pl-2 position-relative mb-2"
      >
        <div class="flex-grow-1 ml-3 d-flex">
          <div style="width: 400px">
            <p class="mb-1 font-weight-bold hide-text">{{ 'No Email Found' }}</p>
          </div>
        </div>
        <div class="position-absolute red-area cursor-pointer">
          <v-icon color="white">{{ mdiChevronRight }}</v-icon>
        </div>
      </div>
    </div>
    <div v-else>
      <CrmEmailView
        :email-data="emailData"
        :email-view-data="emailViewData"
        :prop-type="propType"
        @close-email-view="isEmailDetailsOpen = false"
        @refreshEmail="refreshEmail"
      />
    </div>
  </div>
</template>
<script>
import { ref, watch } from '@vue/composition-api'
import { mdiChevronRight } from '@mdi/js'
import { useRouter } from '@core/utils'
import useEmailService from '@/components/email/useEmailService'
import { formatDateToMonthShort } from '@core/utils/filter'
import { storeActions } from '@/store/storeConstants'
import store from '@/store'
import CrmEmailView from './CrmEmailView.vue'

export default {
  components: { CrmEmailView },
  props: {
    propType: {
      type: String,
      required: true,
    },
    propId: {
      type: String,
      required: true,
    },
  },
  setup(props, ctx) {
    const { fetchModuleThread } = useEmailService()
    const { CREATE } = storeActions
    const isVisibleThread = ref(false)
    const { route } = useRouter()
    const isEmailDetailsOpen = ref(false)
    const emailViewData = ref({})
    const emailData = ref([])
    const emailPage = ref(1)
    const response = ref([])
    const count = ref(0)
    const loading = ref(false)

    const visibleThread = () => {
      isVisibleThread.value = true
    }

    const loadMore = () => {
      emailPage.value = 1
      const payload = {
        component: 'email/threads',
        filter: {
          prop_id: props.propId,
          prop_type: props.propType,
          limit: 10,
          offset: 0,
        },
      }
      loading.value = true
      store
        .dispatch(`common/${storeActions.GET_ALL_RECORDS}`, payload)
        .then(({ data }) => {
          loading.value = false
          if (data.success) {
            response.value = data.data
            if (data.meta !== undefined) {
              count.value = data.meta.count
            }
          } else {
            response.value = []
            count.value = 0
          }
        })
        .catch(() => {
          loading.value = false
        })
    }

    const updateEmailViewData = async (email, reload = false) => {
      if (email.thread_id === emailViewData.value.thread_id && emailData.value.length && !reload) {
        isEmailDetailsOpen.value = true
      } else {
        emailViewData.value = email
        const data = await fetchModuleThread(email.thread_id)
        // if (!email.unread) {
        //   toggleEmailRead(email, false)
        // }
        isEmailDetailsOpen.value = true
        emailData.value = data
      }
    }

    const refreshEmail = () => {
      const payLoad = {
        component: 'email/map',
        object: {
          prop_type: props.propType,
          prop_id: props.propId,
          thread_id: emailViewData.value.thread_id,
        },
      }
      store
        .dispatch(`common/${CREATE}`, payLoad)
        .then(() => {
          loading.value = false
        })
        .finally(() => {
          updateEmailViewData(emailViewData.value, true)
        })
    }

    const infiniteScrolling = (entries, observer, isIntersecting) => {
      if (!isIntersecting) return
      if ((emailPage.value - 1) * 10 < count.value) {
        emailPage.value += 1
        const payload = {
          component: 'email/threads',
          filter: {
            prop_id: props.propId,
            prop_type: props.propType,
            limit: 10,
            offset: 10 * (emailPage.value - 1),
          },
        }
        loading.value = true
        store
          .dispatch(`common/${storeActions.GET_ALL_RECORDS}`, payload)
          .then(({ data }) => {
            loading.value = false
            if (data.success && data.data) {
              response.value.push(...data.data)
              if (data.meta !== undefined) {
                count.value = data.meta.count
              }
            } else {
              response.value = []
              count.value = 0
              emailPage.value = 1
            }
          })
          .catch(() => {
            response.value = []
            count.value = 0
            emailPage.value = 1
          })
      }
    }

    watch(
      () => props.propId,
      () => {
        isEmailDetailsOpen.value = false
        loadMore()
      },
      { immediate: true },
    )

    return {
      response,
      refreshEmail,
      loading,
      emailData,
      emailViewData,
      visibleThread,
      infiniteScrolling,
      loadMore,
      isVisibleThread,
      isEmailDetailsOpen,
      updateEmailViewData,
      formatDateToMonthShort,

      // icon
      mdiChevronRight,
    }
  },
}
</script>
<style scoped lang="scss">
.email-card {
  border: 1px solid #dbe5ed;
  box-shadow: 0px 8px 9px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  height: 90px;
}

.receiver {
  background: #eee;
}
.sender {
  background: #fdf5ff;
}

.red-area {
  right: 0;
  width: 40px;
  background: #e17759;
  height: 90px;
  bottom: -1px;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.reply-area {
  right: 60px;
  bottom: 10px;
}
.date-area {
  right: 60px;
  top: 10px;
}

.hide-text {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
